module.exports = __webpack_public_path__ + "img/screen.de451492.jpeg";